<template>
  <div class="water-views">
    <div v-if="loading" class="loading-box"> 
      <loading-view></loading-view>
      <p>正在加载中</p>
    </div>
 
  
    <div class="grid-box" :style="{ height: `${maxHieght}px`,opacity:loading?0:1 }">
      <div
        class="grid-item wow bounceInUpSlow"
        :data-wow-delay="`${0.2 * index}s`"
        v-for="(item,index) in state.items"
        :key="item.key"
      >
        <img :src="item.img" alt @load="imgLoad" />
      </div>
    </div>
  </div>
</template>
<script setup>
  import LoadingView from './LoadingView.vue'
import { nextTick, reactive, watch, ref, defineProps } from 'vue';
import img01 from '@/assets/images/other/pic_1.png';
import img02 from '@/assets/images/share-img01.png';
import img03 from '@/assets/images/wenming-img.png';
import img04 from '@/assets/images/other/product-case04.png';
import img05 from '@/assets/images/product-img02.png';
import img06 from '@/assets/images/other/product-case04.png';
import img07 from '@/assets/images/product-img02.png';
import img08 from '@/assets/images/share-img01.png';
const props = defineProps({
  items: {
    type: Array
  }
})
const loading =  ref(true)
const maxHieght = ref(100)
const state = reactive({
  colArr: [],
  items: props.items
})
const lodeIndex = ref(0)
const initWater = () => {
  let box = document.querySelector('.grid-box');
  let items = box.children;
  let itemWidth = parseInt(box.offsetWidth / 4)
  waterFall(box, items, itemWidth);
  //对num张照片进行瀑布流布局
}
function waterFall(box, items, itemWidth) {
  let columns = 4;
  for (let i = 0; i < items.length; i++) {
    if (i < columns) {
      // 对第一行图片进行布局
      items[i].style.top = 0;
      items[i].style.left = (itemWidth) * i + 'px';
      console.log(items[i].offsetHeight, 'items[i]');
      state.colArr.push(items[i].offsetHeight);
    } else {
      let minHeight = state.colArr[0];
      let index = 0;
      for (let j = 0; j < state.colArr.length; j++) {
        if (minHeight > state.colArr[j]) {
          minHeight = state.colArr[j];
          index = j;
        } else { }
      }
      items[i].style.top = state.colArr[index] + 'px';
      items[i].style.left = items[index].offsetLeft + 'px';

      // 修改最小列的高度
      // 最小列的高度 = 当前自己的高度 + 拼接过来的高度 + 间隙的高度
      state.colArr[index] = state.colArr[index] + items[i].offsetHeight;
      maxHieght.value = state.colArr[index]
    }
  }
}

const imgLoad = (e) => {
  if (lodeIndex.value == state.items.length - 1) {
    console.log(lodeIndex.value, state.items.length);
    loading.value = false
    initWater()
  } else if (lodeIndex.value < state.items.length - 1) {
    lodeIndex.value++
  }

}
</script>
<style lang="less" scoped>
  .loading-box{
    text-align: center;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p{
      color:var(--blue600);
      position: relative;
      top:-10px;
    }
  }
.grid-box {
  position: relative;
  margin-top: 12px;
}
.grid-item {
  position: absolute;
  width: 25%;
  padding: 16px 12px;

  img {
    display: block;
    width: 100%;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease-in-out;
  }
  &:hover {
    img {
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
      transition: all 0.2s ease-in-out;
    }
  }
}
</style>